document.addEventListener('DOMContentLoaded', function() {
  // Hardcoded license key for testing
  const licenseKey = "45c4c34a6faa3d01d217f390338a4e6c"; 

  // Get the current store URL dynamically
  const storeUrl = "https://" + window.location.hostname;

  // Log the values to debug
  console.log("Entered License Key:", licenseKey);
  console.log("Entered Store URL:", storeUrl);

  // Check if the entered license key and store URL are valid
  if (validateLicense(licenseKey, storeUrl)) {
    // License is valid, so hide the content and overlay
    document.getElementById('theme-content').style.display = 'none'; // Hide content if license is valid
    document.getElementById('theme-overlay').style.display = 'none'; // Hide the overlay
  } else {
    // License is invalid, so show the content and overlay
    document.getElementById('theme-content').style.display = 'block'; // Show content if invalid license
    document.getElementById('theme-overlay').style.display = 'flex'; // Show overlay
  }
});

// Function to validate license key and store URL
function validateLicense(key, url) {
  const validKey = "45c4c34a6faa3d01d217f390338a4e6c";  // Correct License Key
  const validUrls = [
    "https://gulmohar-jaipur.myshopify.com",
    "https://gulmoharjaipur.in",
    "https://www.gulmoharjaipur.in",
    "https://admin.shopify.com/"
  ];
  
  // Check if the input matches the valid values
  return key === validKey && validUrls.includes(url);
}